import { ANALYTICS_BASE_PATH, ANALYTICS_BASE_PATH_HP123 } from './screenPaths'
import { ACTIVITY } from './activity'

export const SCREENS = {
  SETUP_TAB: {
    screenName: 'SetupTab',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  LEARN_TAB: {
    screenName: 'LearnTab',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  GET_HELP_TAB: {
    screenName: 'GetHelpTab',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  INSTALL_HP_MOBILE: {
    screenName: 'InstallHpApp',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH_HP123
  },
  LANDING_PAGE: {
    screenName: 'LandingPage',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH_HP123
  },
  INSTALL_UNSUPPORTED_OS: {
    screenName: 'InstallUnsupportedOs',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  INSTALL_CHINA: {
    screenName: 'InstallChina',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  PAGE_NOT_FOUND: {
    screenName: 'PageNotFound',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  'power-on': {
    screenName: 'PowerOn',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  'install-ink': {
    screenName: 'InstallInk',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  'load-paper': {
    screenName: 'LoadPaper',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  'hp-software': {
    screenName: 'HpSoftwareTrillium',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  'hp-software-skyline': {
    screenName: 'HpSoftwareSkyline',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  alignment: {
    screenName: 'Alignment',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  purger: {
    screenName: 'Purger',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  printheads: {
    screenName: 'Printheads',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  ACCOUNT_TYPE: {
    screenName: 'AccountType',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  SETUP_CHECKLIST: {
    screenName: 'SetupChecklist',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  CONNECT_USB: {
    screenName: 'ConnectUsb',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  UNSUPPORTED_OS: {
    screenName: 'UnsupportedOs',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH_HP123
  },
  SET_UP_CHROMEBOOK: {
    screenName: 'SetUpChromebook',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  SET_UP_LINUX: {
    screenName: 'SetUpLinux',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  SELECT_USB: {
    screenName: 'SelectUsb',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  INSTALL_DRIVER: {
    screenName: 'InstallDriver',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  INSTALL_DRIVER_INTRANET: {
    screenName: 'InstallDriverIntranet',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  DRIVER_NOT_FOUND: {
    screenName: 'NoDriverFound',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  DOWNLOADING_DRIVER: {
    screenName: 'DownloadingDriver',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  DRIVER_SUCCESS: {
    screenName: 'DriverSuccess',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  INSTALL_SOFTWARE: {
    screenName: 'InstallSoftware',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  FINISH_SETUP_BUSINESS: {
    screenName: 'FinishSetupSmb',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  SKIP_INTERNET_CONNECTION: {
    screenName: 'SkipInternetConnection',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  START_AIRPRINT: {
    screenName: 'StartPrintingWithAirPrint',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  STAR_PRINTING_MOBILE: {
    screenName: 'MobileInstallation',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  HP_SMART_INSTALLATION: {
    screenName: 'HpSmartInstallation',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: `${ANALYTICS_BASE_PATH}GetHelp/`
  },
  PRIVACY_FOOTER: {
    screenName: 'PrivacyFooter',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  },
  SEARCH_PAGE: {
    screenName: 'SearchPage',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH_HP123
  },
  INSTALL_HP_APP: {
    screenName: 'InstallHpApp',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH_HP123
  },
  DEVICE_NOT_LISTED_INSTALL_HP_APP: {
    screenName: 'DeviceNotListedInstallHpApp',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH_HP123
  },
  LASERJET_INSTALL_HP_APP: {
    screenName: 'LaserJetInstallHpApp',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH_HP123
  },
  ALL_IN_PLAN_WELCOME: {
    screenName: 'AllInPlanWelcome',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH_HP123
  },
  INSTALL_HP_EASY_START: {
    screenName: 'InstallHpEasyStart',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH_HP123
  },
  INSTALL_HP_EASY_START_GENERIC: {
    screenName: 'InstallHpEasyStartGeneric',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH_HP123
  },
  INSTALL_DRIVERS: {
    screenName: 'InstallDrivers',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH_HP123
  },
  USB_INSTALL_HP_APP: {
    screenName: 'UsbInstallHpApp',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH_HP123
  },
  UNABLE_TO_FIND_PAGE: {
    screenName: 'UnableToFindPage',
    activity: ACTIVITY.HARDWARE_SETUP,
    screenPath: ANALYTICS_BASE_PATH
  }
}
